module.exports = __webpack_public_path__ + "static/media/circle.1541da91.svg";